<style lang="scss">
.m1.slide-18 {
  background-image: url(../../../assets/module1/slide18/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-left: 50px;
  padding-top: 70px;
  height: calc(100% - 70px);
  h1 {
    font-size: 74px;
    color: #c5d43b;
    display: flex;
    flex-direction: column;
    max-width: 929px;
    margin-bottom: 40px;
    span {
      display: block;
      margin-left: auto;
      margin-right: auto;
      &:nth-of-type(1),
      &:nth-of-type(2) {
        transform: rotate(-4deg) translateY(-5px);
      }
      &:last-of-type {
        font-size: 95px;
        transform: translateX(60px);
      }
    }
  }
  .content {
    max-width: 780px;
    margin-left: 100px;
  }
  p {
    margin-bottom: 50px;
  }
  h2 {
    font-size: 120px;
    position: absolute;
    top: 180px;
    right: 20px;
  }
}
</style>

<template>
  <div class="slide-18 m1">
    <transition name="fadeRight" appear>
      <img
        src="@/assets/module1/slide18/franc-01.png"
        class="chars delay-4"
        v-show="slideIndex == 17"
      />
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 17">
        <h1 v-html="$t('module1.slide18.heading')"></h1>
      </div>
    </transition>
    <transition name="fadeLeft" appear>
      <h2 v-show="slideIndex == 17" class="delay-5">Frank</h2>
    </transition>
    <div class="content">
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 17" class="delay-1">
          <p>{{ $t("module1.slide18.paragraph") }}</p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 17" class="delay-2">
          <p>{{ $t("module1.slide18.paragraph2") }}</p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 17" class="delay-3">
          <p>{{ $t("module1.slide18.paragraph3") }}</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
